import styles from "./FeaturedNewsCard.module.scss";
import React from "react";
import * as DateIso from "@tiicker/util/lib/date-iso";
import classNames from "classnames";
import Button from "components/core/Button/Button";
import InsightShare from "components/InsightShare/InsightShare";

type Props = {
  className?: string;
  logoUrl?: string;
  date: Date;
  title: string;
  description: string;
  slug: string;
  publicationLogo?: string;
};

const FeaturedNewsCard = (props: Props) => {
  const date = DateIso.toIsoDate(props.date);
  console.log(props.slug);

  const url = `${
    typeof window !== "undefined" && window.location.host
  }/press-release/${props.slug}`;

  return (
    <div className={classNames(styles.card, props.className)}>
      <div>
        <div className={styles.logoContainer}>
          {props.publicationLogo && (
            <img src={props.publicationLogo} className={styles.logo} />
          )}
          <p className={styles.date}>{DateIso.formatLongMonthDayYear(date)}</p>
        </div>
        <h3 className={styles.title}>{props.title}</h3>
        <p className={styles.description}>{props.description}</p>
      </div>
      <div className={styles.buttonContainer}>
        <Button arrow href={`/news/${props.slug}`}>
          View Original Article
        </Button>
        <InsightShare title={props.title} slug={props.slug} urlOverride={url} />
      </div>
    </div>
  );
};

export default FeaturedNewsCard;
